import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  SELECT_REPORT_OPTIONS,
  REPORT_TYPE_OPTIONS,
  DIMENSION_OPTIONS,
  STATEMENT_DATA_LIST,
  STATEMENT_DATA_LABEL,
  REPORT_TYPE_OPTIONS_MAP,
  DIMENSION_OPTIONS_MAP,
} from './MMEConstants';
import MMEVariableSelection from './MMEVariableSelection';
import GenericCheckboxList from '../common/GenericCheckboxList';
import CommonSelect from '../common/CommonSelect';

class MMEReportOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportType: props.selectedReportType ?
        props.selectedReportType : REPORT_TYPE_OPTIONS[0].value,
      showDataVariables: true,
      selectedSecondOption: props.selectedDimensionType ? props.selectedDimensionType : 0,
      selectedReportLabel: props.selectedReportType ?
        REPORT_TYPE_OPTIONS_MAP[props.selectedReportType] : REPORT_TYPE_OPTIONS[0].label,
      selectedDimensionLabel: props.selectedDimensionType ?
        DIMENSION_OPTIONS_MAP[props.selectedDimensionType] : DIMENSION_OPTIONS[0].label,
    };
  }

  // eslint-disable-next-line react/sort-comp
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.selectedDimensionType !== nextProps.selectedDimensionType) {
      this.setState({
        selectedSecondOption: nextProps.selectedDimensionType,
        selectedDimensionLabel: DIMENSION_OPTIONS_MAP[nextProps.selectedDimensionType]
      })
    }
  }

  componentDidMount() {
    this.mountThis();
  }

  changeReportType = e => {
    const selectedType = e;
    if (selectedType === REPORT_TYPE_OPTIONS[0].value) {
      this.setState({ reportType: selectedType,
        showDataVariables: true,
        selectedReportLabel: REPORT_TYPE_OPTIONS_MAP[e],
      }, () => {
        this.props.updateReportType(selectedType);
      });
    } else {
      this.setState({ reportType: selectedType,
        showDataVariables: false,
        selectedReportLabel: REPORT_TYPE_OPTIONS_MAP[e],
      }, () => {
        this.props.updateReportType(selectedType);
      });
    }
  }

  changeDimensionType = e => {
    const selectedType = e;
    this.setState({
      selectedSecondOption: selectedType,
      selectedDimensionLabel: DIMENSION_OPTIONS_MAP[e],
    }, () => {
      this.props.updateDimensionType(selectedType);
    });
  }

  updateStatementList = e => {
    const { selectedDimensionType = 0, statementList } = this.props;
    this.props.onChangeProperty(Number(selectedDimensionType), statementList, e, 'statementList');
  };

  updateDimensionList = e => {
    const { selectedDimensionType = 0, dimensionList } = this.props;
    this.props.onChangeProperty(Number(selectedDimensionType), dimensionList, e, 'dimensionList');
  };

  mountThis() {
    const { selectedReportType } = this.props;
    if (selectedReportType && selectedReportType !== REPORT_TYPE_OPTIONS[0].value) {
      this.setState({
        reportType: selectedReportType,
        showDataVariables: false,
      });
    }
  }


  renderDimensionSelect = () => {
    let updatedDimensionOptions = DIMENSION_OPTIONS;
    if (this.props.statementList && !this.props.statementList[4].length) {
      updatedDimensionOptions = updatedDimensionOptions.filter(option => option.value !== 4)
    }
    return (
      <CommonSelect
        data-test="CustomSelectComp"
        cClass="mme-rpt-second-select"
        field={updatedDimensionOptions}
        onSelection={this.changeDimensionType}
        defaultValue={this.state.selectedSecondOption}
        defaultLabel={this.state.selectedDimensionLabel}
        width="175px"
        buttonStyle={{ border: '1px solid #91a2b9', fontWeight: '400', color: '#30435d', height: '30px' }}
      />
    )
  }

  renderReportSelect = () => (
    <CommonSelect
      data-test="CustomSelectComp"
      cClass="mme-rpt-select"
      field={REPORT_TYPE_OPTIONS}
      onSelection={this.changeReportType}
      defaultValue={this.state.reportType}
      defaultLabel={this.state.selectedReportLabel}
    />
  )

  renderStatementData = () => (
    <div className="checkboxList">
      <GenericCheckboxList
        data-test="StatementCheckboxList"
        options={this.props.statementList[this.state.selectedSecondOption]}
        allCheckboxTitle={`${DIMENSION_OPTIONS[this.state.selectedSecondOption].label} Statements `}
        updateList={this.updateStatementList}
        unique="v"
      />
    </div>
  );

  renderStatementVariableData = () => (
    <div className="mme-rpt-stmt-right">
      <span className="mme-rpt-stmt-right-label">{STATEMENT_DATA_LABEL}</span>
      <MMEVariableSelection
        data-test="VariableSelectionComp"
        data={STATEMENT_DATA_LIST}
        selectedOptions={this.props.selectedStatementVariables}
        updateSelectedAction={this.props.updateSelectedAction}
      />
    </div>
  );

  render() {
    const { showDataVariables } = this.state;
    return (
      <div data-test="ReportOptionsComp">
        <span className="heading-label">{SELECT_REPORT_OPTIONS}</span>
        <div className="mme-rpt">
          {this.renderReportSelect()}
        </div>
        <div className="mme-rpt-second">
          {this.renderDimensionSelect()}
        </div>
        {this.props.statementList && <div className="mme-rpt-stmt">
          <div className="mme-rpt-stmt-left">
            {this.state.reportType === REPORT_TYPE_OPTIONS[0].value && this.props.statementList &&
              this.renderStatementData()
            }
            {this.state.reportType !== REPORT_TYPE_OPTIONS[0].value && this.props.dimensionList &&
              <div className="checkboxList">
                <GenericCheckboxList
                  data-test="DimensionCheckboxList"
                  options={this.props.dimensionList[this.state.selectedSecondOption]}
                  allCheckboxTitle={`${DIMENSION_OPTIONS[this.state.selectedSecondOption].label} Dimensions `}
                  updateList={this.updateDimensionList}
                  unique="v"
                />
              </div>
            }
          </div>
          {showDataVariables && this.renderStatementVariableData()}
        </div>}
      </div>
    );
  }
}

MMEReportOptions.propTypes = {
  statementList: PropTypes.shape({}),
  selectedStatementVariables: PropTypes.instanceOf(Array),
  updateSelectedAction: PropTypes.func,
  updateReportType: PropTypes.func,
  selectedReportType: PropTypes.string,
  dimensionList: PropTypes.shape({}),
  updateDimensionType: PropTypes.func,
  selectedDimensionType: PropTypes.number,
  onChangeProperty: PropTypes.func,
};

export default MMEReportOptions;
